import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MSGraphAPIService {

  constructor(private readonly httpClient: HttpClient) {}

  changePassword(oldPassword: string, newPassword: string, accessToken: string): Observable<any> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    });

    const body = {
      currentPassword: oldPassword,
      newPassword: newPassword
    };

    return this.httpClient.post(`${environment.graphAPIUrl}me/changePassword`, body, { headers });
  }
}
